import React, { useEffect, useState } from "react";
import { getApiUrl } from "../utils/api";

const Sizecomponent = () => {
  const [sizeCharts, setSizeCharts] = useState([]);

  const fetchSizeCharts = async () => {
    try {
      const res = await fetch(getApiUrl("getcharts"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({})
      });

      const result = await res.json();
      if (result.success) {
        setSizeCharts(result.data);
      }
    } catch (error) {
      console.log("Failed to fetch size charts");
    }
  };

  useEffect(() => {
    fetchSizeCharts();
  }, []);

  return (
    <div className="container mt-4">
      <h3 className="mb-4 text-center page-title">Size Charts</h3>

      {sizeCharts.length > 0 ? (
        sizeCharts.map((chart) => (
          <div key={chart._id} className="size-card mb-5">
            
            <h5 className="chart-title">{chart.chartName}</h5>

            <div className="table-responsive-custom">
              <table className="table shadow-table">
                <thead>
                  <tr>
                    <th>Size</th>
                    <th>Bust</th>
                    <th>Waist</th>
                    <th>Hip</th>
                    <th>Top Length</th>
                    <th>Pant Length</th>
                    <th>Thigh</th>
                  </tr>
                </thead>

                <tbody>
                  {chart.sizes?.length > 0 ? (
                    chart.sizes.map((item, index) => (
                      <tr key={index}>
                        <td>{item.size}</td>
                        <td>{item.bust}</td>
                        <td>{item.waist}</td>
                        <td>{item.hip}</td>
                        <td>{item.topLength}</td>
                        <td>{item.pantLength}</td>
                        <td>{item.thigh}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No size details found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          </div>
        ))
      ) : (
        <p className="text-center">No size charts found.</p>
      )}
    </div>
  );
};

export default Sizecomponent;
